export type ConsumerAccountTab =
  | "yhteenveto"
  | "paikat"
  | "kalareissut"
  | "kalapakki"
  | "saaliit"
  | "ilmoitukset"
  | "luvat"
  | "tilaukset"
  | "asetukset";

const consumerTabs = new Set<ConsumerAccountTab>([
  "paikat",
  "kalareissut",
  "kalapakki",
  "saaliit",
  "ilmoitukset",
  "luvat",
  "tilaukset",
  "asetukset",
]);

export const consumerAccountTabMeta: Partial<
  Record<ConsumerAccountTab, { title: string; description: string }>
> = {
  paikat: {
    title: "Omat kalapaikat",
    description:
      "Tallennetut järvet ja joet sekä nopea paluu paikkakohtaiseen lupahakuun.",
  },
  kalareissut: {
    title: "Kalareissut",
    description: "Suunnittele tulevat reissut ja tarkista lupa ennen lähtöä.",
  },
  kalapakki: {
    title: "Oma Kalapakki",
    description: "Pidä vieheet, värit, koot ja tavoitelajit yhdessä yksityisessä näkymässä.",
  },
  saaliit: {
    title: "Omat saaliit",
    description:
      "Reissupäiväkirjojen saaliit, vapautukset ja omiin välineisiin perustuvat havainnot.",
  },
  ilmoitukset: {
    title: "Ilmoitukset ja seuranta",
    description: "Seuraa pyytämiesi vesistöjen täydentymistä ja julkaistun tiedon muutoksia.",
  },
  luvat: {
    title: "Omat luvat",
    description:
      "Voimassaolo, varmennuksen tila ja henkilökohtaisessa lupaohjeessa huomioitavat luvat.",
  },
  tilaukset: {
    title: "Tilaukset ja kuitit",
    description: "Lupava.fi:n kautta tehdyt ostot, maksujen tila ja kuitit.",
  },
  asetukset: {
    title: "Omat asetukset",
    description: "Kalastustavan oletukset, muistutukset sekä tilin suojaus.",
  },
};

export const consumerAccountNavigation: Array<{
  tab: ConsumerAccountTab;
  href: string;
  label: string;
  icon: "overview" | "place" | "trip" | "tackle" | "catch" | "alert" | "permit" | "order" | "settings";
}> = [
  { tab: "yhteenveto", href: "/oma", label: "Yhteenveto", icon: "overview" },
  { tab: "paikat", href: "/oma/paikat", label: "Omat paikat", icon: "place" },
  { tab: "kalareissut", href: "/oma/kalareissut", label: "Kalareissut", icon: "trip" },
  { tab: "kalapakki", href: "/oma/kalapakki", label: "Kalapakki", icon: "tackle" },
  { tab: "saaliit", href: "/oma/saaliit", label: "Saaliit", icon: "catch" },
  { tab: "ilmoitukset", href: "/oma/ilmoitukset", label: "Ilmoitukset", icon: "alert" },
  { tab: "luvat", href: "/oma/luvat", label: "Omat luvat", icon: "permit" },
  { tab: "tilaukset", href: "/oma/tilaukset", label: "Tilaukset", icon: "order" },
  { tab: "asetukset", href: "/oma/asetukset", label: "Asetukset", icon: "settings" },
];

export function resolveConsumerAccountRoute(pathname: string): {
  tab: ConsumerAccountTab;
  tripDetailId: string;
  catchDetailId: string;
} {
  const segments = pathname.replace(/^\/oma\/?/, "").split("/");
  const segment = segments[0] ?? "";
  const tab = consumerTabs.has(segment as ConsumerAccountTab)
    ? (segment as ConsumerAccountTab)
    : "yhteenveto";
  return {
    tab,
    tripDetailId:
      tab === "kalareissut" && segments[1]
        ? decodeURIComponent(segments[1])
        : "",
    catchDetailId:
      tab === "saaliit" && segments[1]
        ? decodeURIComponent(segments[1])
        : "",
  };
}
